import { useEffect, useState } from "react";
import "@/App.css";
import { translations, AGENT, resolveAgent, slugify } from "@/data/i18n";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import About from "@/components/landing/About";
import Amenities from "@/components/landing/Amenities";
import Gallery from "@/components/landing/Gallery";
import Typologies from "@/components/landing/Typologies";
import PriceTable from "@/components/landing/PriceTable";
import Location from "@/components/landing/Location";
import AgentCard from "@/components/landing/AgentCard";
import Footer from "@/components/landing/Footer";

function App() {
  const [lang, setLang] = useState("pt");
  const t = translations[lang];

  const [slug] = useState(() =>
    slugify(new URLSearchParams(window.location.search).get("agente")),
  );
  const [agent, setAgent] = useState(AGENT);

  useEffect(() => {
    if (!slug) return;
    let active = true;
    fetch(`${process.env.PUBLIC_URL}/data/agents.json`, { cache: "no-cache" })
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then((d) => active && setAgent(resolveAgent(d, slug)))
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [slug]);

  return (
    <div data-testid="app-root" className="bg-[#0A0A0A]">
      <Navbar />
      <main>
        <Hero t={t} />
        <About t={t} />
        <Amenities t={t} />
        <Gallery t={t} />
        <Typologies t={t} />
        <PriceTable t={t} lang={lang} agent={agent} />
        <Location t={t} />
        <AgentCard t={t} agent={agent} />
      </main>
      <Footer t={t} agent={agent} />
    </div>
  );
}

export default App;
